import React from "react";
import { Modal, Button } from "react-bootstrap";

const QueryDetailModal = ({ show, onHide, query }) => {
  if (!query) return null;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Query Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {query.name}
        </p>
        <p>
          <strong>Email:</strong> {query.email}
        </p>
        <p>
          <strong>Phone Number:</strong> {query.phone}
        </p>
        <p>
          <strong>Subject:</strong> {query.subject}
        </p>
        <p>
          <strong>Query:</strong> {query.query}
        </p>
        <p>
          <strong>Created Date : </strong> {formatDate(query.createdAt)}
        </p>
        <p>
          <strong>Updated Date : </strong> {formatDate(query.updatedAt)}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QueryDetailModal;
